export enum CancellationFlow {
  ASYNC = 'asynchronous',
  AUTO = 'automated',
  SITTER_INITIATED_ASYNC = 'asynchronous-sitter-cancel-for-owner',
}
